import { signOut } from 'firebase/auth';
import React from 'react';
import { useAuthState } from 'react-firebase-hooks/auth';
import { Link } from 'react-router-dom';
import auth from '../../firebase.init';

const Navbar = () => {
    const [user, loading, error] = useAuthState(auth);

    const logout = () => {
        signOut(auth);
        localStorage.removeItem('accessToken')
    };
    const links = <>
        <li><Link to='/'>Home</Link></li>
        <li><Link to='/blogs'>Blogs</Link></li>
        <li><Link to='/myPortfolio'>My Portfolio</Link></li>
        {
            user && <>
                <li><Link to='/dashBoard'>DashBoard</Link></li>
            </>
        }
    </>

    return (
        <nav>
            <div class="navbar bg-base-100">
                <div class="navbar-start">
                    <div class="dropdown">
                        <label tabindex="0" class="btn btn-ghost lg:hidden">
                            <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 6h16M4 12h8m-8 6h16" /></svg>
                        </label>
                        <ul tabindex="0" class="menu menu-compact dropdown-content mt-3 p-2 shadow bg-base-100 rounded-box w-52">
                            {links}
                        </ul>
                    </div>
                    <Link to={'/'} class="btn btn-ghost normal-case text-xl">Best Tech</Link >
                </div>
                <div class="navbar-center hidden lg:flex">
                    <ul class="menu menu-horizontal p-0">
                        {links}
                    </ul>
                </div>
                <div class="navbar-end">
                    {
                        user && <>
                            <span className='text-primary font-bold text-sm mr-1 lg:block hidden'>{user.displayName}</span>
                            <label for="dashboard-slider" tabindex="1" class="btn btn-ghost lg:hidden">
                                <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 6h16M4 12h8m-8 6h16" /></svg>
                            </label>
                        </>

                    }
                    {
                        user ?
                            <Link onClick={logout} to={'/'} class="btn btn-accent">Sign Out</Link>
                            :
                            <Link to={'/login'} class="btn btn-accent">Login</Link>
                    }

                </div>
            </div>
        </nav>
    );
};

export default Navbar;